class EditFavouriteTransactionRequestDTO {
  appTransactionId: number;
  requestData: string;
  description: string;
  transactionStatus: number;
  enabled: boolean;

  constructor(
    appTransactionId: number,
    requestData: string,
    description: string,
    transactionStatus: number,
    enabled: boolean,
  ) {
    this.appTransactionId = appTransactionId;
    this.requestData = requestData;
    this.description = description;
    this.transactionStatus = transactionStatus;
    this.enabled = enabled;
  }
}

export { EditFavouriteTransactionRequestDTO };
